import { render, staticRenderFns } from "./FooterStrip.vue?vue&type=template&id=b81d3de0"
import script from "./FooterStrip.vue?vue&type=script&lang=js"
export * from "./FooterStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports